import CustomTable from '@/components/CustomTable/CustomTable.vue';
import IconCard from "@/components/CustomCard/IconCard.vue";
import { useToast } from "@/components/Toast/useToast.js";
import { format_date } from "@/utils/date_formatter";
import { API_BASE_URL } from "@/config";
import { validateToken } from '@/utils/auth';
import { LOGOUT } from "@/utils/logout.js";

export default {
  name: 'ProjectDashboard',
  mixins: [LOGOUT], 
  setup() {
    const { showSuccess, showError } = useToast();
    
    return {
      showSuccess,
      showError
    };
  },
  data: () => ({
    workflows: [],
    workflow_name: '',
    workflow_description: '',
    allow_multiple_onboading: false,
    multiple_onboarding: false,
    batch_onboarding: false,
    store_on_api: false,
    customers: 0,
    active_workflows: 0,
    admins: 0,
    project_name: '',
    project_description: '',
    loading: false,
    role: '',
    total_project_customers: 0,
    current_workflow_id: null,
    anonymous_email: '',
    anonymous_phone: '',
    qr_code_url: '',
    qr_code_loading: false,
    workflowsTableKey: 0,
    can_create_workflow: false,
    isInitializing: true,
    activePopupWorkflowId: null,
    columns: [
      { label: 'Workflow Name', key: 'workflow_name' },
      { label: 'Workflow Status', key: 'workflow_status' },
      { label: 'Workflow State', key: 'workflow_state' },
      { label: 'Date Created', key: 'date_created' },
    ],
  }),
  components: {
    CustomTable,
    IconCard
  },
  computed: {
    project_id() {
      return this.$store.getters.get_project_id;
    }
  },
  methods: {
    togglePopup(workflowId) {
      this.activePopupWorkflowId = this.activePopupWorkflowId === workflowId ? null : workflowId;
    },
    getUserData() {
      const TOKEN = localStorage.getItem('token');
      const API_URL = `${API_BASE_URL}/verify_api/system_management_api/get_user_api/`;

      $.ajax({
        url: API_URL,
        method: 'GET',
        headers: {
          Authorization: `Token ${TOKEN}`
        },
        success: (response) => {
          if (response.redirect) {
            this.logout();
            return;
          }
          
          if (response.status === 'success') {
            const userData = response.data;
            if (!this.isUserDataLoaded) {
              this.role = userData.user_role;
              this.can_create_workflow = response.can_create_workflow;
              this.isUserDataLoaded = true;
            }

          }
        },
        error: (error) => {
          if (error.responseJSON?.redirect) {
            this.logout();
            return;
          }
          
          this.showError('Error', error.responseJSON?.error || 'Failed to load user data');
        }
      });
    },
    update_complete_notification(workflow_id, complete_notification) {
      const TOKEN = localStorage.getItem('token');
      const API_URL = `${API_BASE_URL}/verify_api/workflow_management_api/complete_notification_change_api/`;

      $.ajax({
        url: API_URL,
        method: 'POST',
        contentType: 'application/json',
        data: JSON.stringify({
          workflow_id: workflow_id,
          complete_notification: complete_notification
        }),
        headers: {
          Authorization: `Token ${TOKEN}`
        },
        success: (response) => {
          if (response.redirect) {
            this.logout();
            return;
          }
          this.showSuccess('Success', response.message);
          this.workflowsTableKey++;
          this.$refs.workflowTable.loadData();
        },
        error: (error) => {
          this.showError('Error', error.responseJSON?.error || 'An error occurred');
        }
      });
    },
    get_project_customers() {
      const TOKEN = localStorage.getItem('token');
      const GET_CUSTOMERS = `${API_BASE_URL}/verify_api/workflow_management_api/get_customers_in_project/${this.project_id}`;

      $.ajax({
        url: GET_CUSTOMERS,
        method: 'GET',
        contentType: 'application/json',
        headers: {
          Authorization: `Token ${TOKEN}`
        },
        success: (response) => {
          if (response.redirect) {
            this.logout();
          }
          this.total_project_customers = response.total_customers;
          this.$nextTick(() => {
          });
        },
        error: (error) => {
          this.showError('Error', error.responseJSON?.error || 'Failed to load customer data');
        }
      });
    },
    get_project_data() {
      const TOKEN = localStorage.getItem('token');
      const GET_PROJECT_DATA_API = `${API_BASE_URL}/verify_api/workflow_management_api/get_project_data_api/${this.project_id}`;

      $.ajax({
        url: GET_PROJECT_DATA_API,
        method: 'GET',
        contentType: 'application/json',
        headers: {
          Authorization: `Token ${TOKEN}`
        },
        success: (response) => {
          if (response.redirect) {
            this.logout();
          }
          this.customers = response.customers;
          this.active_workflows = response.active_workflows;
          this.admins = response.admins || 0;
          this.project_name = response.project_name
          this.project_description = response.project_description;
          this.role = response.user_role;
        },
        error: () => {
          this.showError('Error', 'Failed to load project data');
        }
      });
    },
    getWorkflows(page = 1, search = '') {
      const TOKEN = localStorage.getItem('token');
      return new Promise((resolve, reject) => {
        let url = `${API_BASE_URL}/verify_api/workflow_management_api/get_paginated_project_workflows/${this.project_id}?page=${page}`;
        if (search) {
          url += `&search=${encodeURIComponent(search)}`;
        }
        $.ajax({
          url,
          method: 'GET',
          contentType: 'application/json',
          headers: {
            Authorization: `Token ${TOKEN}`
          },
          success: (response) => {
          const results = response.results.map(item => ({
            ...item,
            disableAnonymousClient: item.has_credit_service,
            disablebehalfApplication: item.has_no_user_interaction
          }));
            resolve({
              count: response.count,
            results
            });
          },
          error: (xhr, status, error) => {
            reject(error);
          }
        });
      });
    },
    formatDate(date) {
      return format_date(date);
    },
    get_status(status) {
      if (status === 'pending') {
        return 'status-pending';
      } else if (status === 'declined') {
        return 'status-declined';
      } else if (status === 'approved') {
        return 'status-active';
      } else if (status === 'incomplete') {
        return 'status-incomplete';
      }
    },
    validate_inputs() {
      if (!this.workflow_name.trim()) {
        $('.workflow-name-messages').removeClass('d-none');
        setTimeout(() => {
          $('.workflow-name-messages').addClass('d-none');
        }, 3000);
        return false;
      }

      if (!this.workflow_description.trim()) {
        $('.workflow-description-messages').removeClass('d-none');
        setTimeout(() => {
          $('.workflow-description-messages').addClass('d-none');
        }, 3000);
        return false;
      }

      return true;
    },

    create_workflow() {
      if (!this.validate_inputs()) {
        return;
      }

      const TOKEN = localStorage.getItem('token');
      const COMPANY_PROFILE_ID = localStorage.getItem('company_profile_id');

      const FORM_DATA = {
        workflow_name: this.workflow_name,
        workflow_description: this.workflow_description,
        store_on_api: this.store_on_api,
        company_profile_id: COMPANY_PROFILE_ID,
        allow_multiple_onboarding: this.multiple_onboarding,
        allow_batch_onboarding: this.batch_onboarding
      };

      const CREATE_WORKFLOW_API = `${API_BASE_URL}/verify_api/workflow_management_api/create_workflow_api/${this.project_id}`;

      $.ajax({
        url: CREATE_WORKFLOW_API,
        method: 'POST',
        contentType: 'application/json',
        data: JSON.stringify(FORM_DATA),
        headers: {
          Authorization: `Token ${TOKEN}`
        },
        success: (response) => {
          localStorage.setItem('user_state', 'created_workflow');
          let status = response.status;

          if (status === 'success') {
            const workflow_id = response.workflow_id;
            const project_id = response.project_id;
            this.$store.commit('set_workflow_id', workflow_id);
            this.$store.dispatch('update_project_id', project_id);
            $('#create_workflow').modal('hide');
            this.showSuccess('Success', 'Workflow created successfully!');
            this.$router.push({ name: 'workflow_services' });
          }
          else {
            let error_message = response.message;
            this.showError('Error', error_message);
          }
        },
        error: (error) => {
          let error_message = 'Error Creating Workflow';

          if (error.responseJSON) {
            const ERROR_RESPONSE = error.responseJSON;

            if (ERROR_RESPONSE && ERROR_RESPONSE.error) {
              error_message = ERROR_RESPONSE.error;

              $('.error-messages').text(error_message).removeClass('d-none');

              setTimeout(() => {
                $('.error-messages').text('').addClass('d-none');
              }, 3000);
            }
          }
          
          this.showError('Error', error_message);
        }
      });
    },
    view_workflow(workflow_id) {
      this.$store.commit('set_workflow_id', workflow_id);
      this.$router.push({ name: 'client_view_workflow' });
    },
    edit_workflow(workflow_id) {
      this.$store.dispatch('update_workflow_id', workflow_id);
      this.$router.push({ name: 'edit_workflow' });
    },
    view_workflow_templates() {
      this.$router.push({ name: 'workflow_templates' });
    },
    toggle_workflow_status(workflow_id, checked) {
      if (checked) {
        this.activate_workflow(workflow_id);
      } else {
        this.deactivate_workflow(workflow_id);
      }
    },
    deactivate_workflow(workflow_id) {
      const TOKEN = localStorage.getItem('token');
      const DEACTIVATE_WORKFLOW_URL = `${API_BASE_URL}/verify_api/workflow_management_api/action_workflow/${workflow_id}`;

      const FORM_DATA = {
        workflow_id: workflow_id,
        action: 'deactivate'
      };

      $.ajax({
        url: DEACTIVATE_WORKFLOW_URL,
        method: 'POST',
        contentType: 'application/json',
        data: JSON.stringify(FORM_DATA),
        headers: {
          Authorization: `Token ${TOKEN}`
        },
        success: (response) => {
          this.showSuccess('Success', response.message);
          this.active_workflows -= 1;
          this.workflowsTableKey++;
          this.$refs.workflowTable.loadData();
        },
        error: () => {
          this.showError('Error', 'An error occurred while deactivating the workflow');
        }
      });
    },
    activate_workflow(workflow_id) {
      const TOKEN = localStorage.getItem('token');
      const ACTIVATE_WORKFLOW_URL = `${API_BASE_URL}/verify_api/workflow_management_api/action_workflow/${workflow_id}`;

      const FORM_DATA = {
        workflow_id: workflow_id,
        action: 'activate'
      };

      $.ajax({
        url: ACTIVATE_WORKFLOW_URL,
        method: 'POST',
        contentType: 'application/json',
        data: JSON.stringify(FORM_DATA),
        headers: {
          Authorization: `Token ${TOKEN}`
        },
        success: (response) => {
          this.showSuccess('Success', response.message);
          this.active_workflows += 1;
          this.workflowsTableKey++;
          this.$refs.workflowTable.loadData();
        },
        error: () => {
          this.showError('Error', 'An error occurred while activating the workflow');
        }
      });
    },
    // Anonymous Client methods
    open_anonymous_client_modal(workflow_id) {
      this.current_workflow_id = workflow_id;
      this.anonymous_email = '';
      this.anonymous_phone = '';
      this.qr_code_url = '';
      this.qr_code_loading = false;

      this.generate_qr_code();

      // Open the modal
      $('#anonymous_client_modal').modal('show');
    },
    send_email_invite() {
      if (!this.anonymous_email) {
        $('.email-error').text('Please enter an email address').removeClass('d-none');
        setTimeout(() => {
          $('.email-error').addClass('d-none');
        }, 3000);
        return;
      }

      const email_regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!email_regex.test(this.anonymous_email)) {
        $('.email-error').text('Please enter a valid email address').removeClass('d-none');
        setTimeout(() => {
          $('.email-error').addClass('d-none');
        }, 3000);
        return;
      }

      const TOKEN = localStorage.getItem('token');
      const API_URL = `${API_BASE_URL}/verify_api/workflow_management_api/send_anonymous_email_invite/`;

      $.ajax({
        url: API_URL,
        method: 'POST',
        contentType: 'application/json',
        data: JSON.stringify({
          workflow_id: this.current_workflow_id,
          email: this.anonymous_email,
          url: this.qr_code_url
        }),
        headers: {
          Authorization: `Token ${TOKEN}`
        },
        success: (response) => {
          if (response.redirect) {
            this.logout();
            return;
          }

          this.showSuccess('Success', response.message || 'Invitation sent successfully!');
          // Close the modal
          $('#anonymous_client_modal').modal('hide');
        },
        error: (error) => {
          this.showError('Error', error.responseJSON?.error || 'Failed to send invitation');
        }
      });
    },
    send_sms_invite() {
      if (!this.anonymous_phone) {
        $('.phone-error').text('Please enter a phone number').removeClass('d-none');
        setTimeout(() => {
          $('.phone-error').addClass('d-none');
        }, 3000);
        return;
      }

      // Simple phone validation - could be enhanced
      if (this.anonymous_phone.length < 10) {
        $('.phone-error').text('Please enter a valid phone number').removeClass('d-none');
        setTimeout(() => {
          $('.phone-error').addClass('d-none');
        }, 3000);
        return;
      }

      const TOKEN = localStorage.getItem('token');
      const API_URL = `${API_BASE_URL}/verify_api/workflow_management_api/send_anonymous_sms_invite/`;

      $.ajax({
        url: API_URL,
        method: 'POST',
        contentType: 'application/json',
        data: JSON.stringify({
          workflow_id: this.current_workflow_id,
          phone: this.anonymous_phone,
          url: this.qr_code_url
        }),
        headers: {
          Authorization: `Token ${TOKEN}`
        },
        success: (response) => {
          if (response.redirect) {
            this.logout();
            return;
          }

          this.showSuccess('Success', response.message || 'SMS invitation sent successfully!');
          // Close the modal
          $('#anonymous_client_modal').modal('hide');
        },
        error: (error) => {
          this.showError('Error', error.responseJSON?.error || 'Failed to send SMS invitation');
        }
      });
    },
    generate_qr_code() {
      this.qr_code_loading = true;
      const TOKEN = localStorage.getItem('token');
      const API_URL = `${API_BASE_URL}/verify_api/workflow_management_api/generate_anonymous_qr_code/`;

      $.ajax({
        url: API_URL,
        method: 'POST',
        contentType: 'application/json',
        data: JSON.stringify({
          workflow_id: this.current_workflow_id
        }),
        headers: {
          Authorization: `Token ${TOKEN}`
        },
        success: (response) => {
          this.qr_code_loading = false;
          if (response.redirect) {
            this.logout();
            return;
          }

          this.qr_code_url = response.url || '';
        },
        error: (error) => {
          this.qr_code_loading = false;
          this.showError('Error', error.responseJSON?.error || 'Failed to generate QR code');
        }
      });
    },
    copy_to_clipboard(text) {
      navigator.clipboard.writeText(text).then(() => {
        this.showSuccess('Copied', 'Link copied to clipboard!');
      }, (err) => {
        console.error('Could not copy text: ', err);
        this.showError('Error', 'Failed to copy to clipboard');
      });
    },
    batch_processing(workflow_id) {
      this.$router.push({name: 'batch_processing', params: {workflow_id: workflow_id}})
    },
    view_batches(workflow_id) {
      this.$router.push({ name: 'view_batches', params: { workflow_id: workflow_id } });
    },
    async behalf_application(workflow_id) {
      const token = localStorage.getItem('token');
      const endpoint = `${API_BASE_URL}/verify_api/workflow_management_api/get_pending_behalf_applications/${workflow_id}/`;

      try {
        const response = await fetch(endpoint, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Token ${token}`
          }
        });

        const result = await response.json();

        if (response.ok && result.status === 'success' && result.data?.pending_applications?.length > 0) {
          // Show dialog with pending applications
          this.showPendingApplicationsDialog(workflow_id);
        } else {
          // No pending applications, ask if user wants to start new application
          this.StartNewApplicationDialog(workflow_id);
        }
      } catch (error) {
        console.error('Error checking for pending applications:', error);
        // Fallback to asking about new application
        this.StartNewApplicationDialog(workflow_id);
      }
    },
    showPendingApplicationsDialog(workflow_id) {
      Swal.fire({
        title: 'Pending Application',
        text: 'You have a pending application. Would you like to complete it or start a new application?',
        icon: 'info',
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: 'Complete Application',
        denyButtonText: 'New Application',
        cancelButtonText: 'Back to Dashboard',
        confirmButtonColor: '#3085d6',
        denyButtonColor: '#28a745',
        cancelButtonColor: '#6c757d'
      }).then(async (result) => {
        if (result.isConfirmed) {
          
          // User wants to complete pending application
          this.$router.push({
              name: 'behalf_application',
              params: { workflowId: workflow_id }
            });
        } else if (result.isDenied) {
          // User wants to start new application
          const token = localStorage.getItem('token');
          const endpoint = `${API_BASE_URL}/verify_api/workflow_management_api/mark_workflow_complete/`;

          try {
            const response = await fetch(endpoint, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Authorization': `Token ${token}`
              },
              body: JSON.stringify({
                workflow_id: workflow_id,
                on_behalf_application: true
              })
            });

            const result = await response.json();

            if (response.ok && result.status === 'success') {
              this.StartNewApplicationDialog(workflow_id);
            } else {
              this.showError(result.message || 'Failed to start new application');
            }
          } catch (error) {
            this.showError('An error occurred while completing the workflow');
          }
        }
      });
    },
    StartNewApplicationDialog(workflow_id) {
      const TOKEN = localStorage.getItem('token');
      const API_URL = `${API_BASE_URL}/verify_api/workflow_management_api/create_behalf_application_api/`;

      // Show loading state
      this.loading = true;

      $.ajax({
        url: API_URL,
        method: 'POST',
        contentType: 'application/json',
        data: JSON.stringify({
          workflow_id: workflow_id
        }),
        headers: {
          Authorization: `Token ${TOKEN}`
        },
        success: (response) => {
          this.loading = false;
          if (response.status === 'success') {
            this.$router.push({
              name: 'behalf_application',
              params: { workflowId: workflow_id }
            });
          } else {
            this.showError(response.message || 'Failed to create behalf application');
          }
        },
        error: (error) => {
          this.loading = false;
          const errorMessage = error.responseJSON?.message || 'An error occurred while creating the behalf application';
          this.showError(errorMessage);
        }
      });
    },
  },
  mounted() {
    if (!(validateToken(this.$router))) {
      return;
    }

    if (this.project_id == null) {

      this.logout();
      return;
    }
    this.getUserData();
    this.get_project_customers();
    this.get_project_data();
    this.getWorkflows();
  }
};
